import { microsoftAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const appModuleSignInPage = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props =>
          (
            <SignInPage
              {...props}
              align="center"
              title="Sign in to Launchpad"
              provider={{
                id: 'microsoft-auth-provider',
                title: 'Microsoft Entra',
                message: 'Sign in using Microsoft Entra ID',
                apiRef: microsoftAuthApiRef,
              }}
            />
          ),
      },
    }),
  ],
});
